/**
 * SQL 편집기 책갈피 — **주석 한 줄이 책갈피다** (2026-10-02).
 *
 *     --@ 고객별 월 집계
 *     SELECT ...
 *
 * 글자로 문서에 들어 있으므로 파일·프로젝트와 함께 저장되고 다른 사람에게도 그대로 간다.
 * 줄 번호를 누르면 그 줄 위에 `--@ ` 를 넣는다(예전의 「저장 안 되는 ●」 는 이것으로 바뀌었다 — 두 종류를
 * 같은 이름으로 부르면 헷갈린다). 편집기(●·줄 강조·미니맵)와 책갈피 탐색기가 **이 파서 하나**를 본다.
 *
 * 주석이므로 실행에는 영향이 없다 — 다음 문장의 앞머리 주석으로 실려 가고, 주석만 있는 조각은
 * 실행 대상에서 빠진다(utils/statementAtCursor).
 */

/** 책갈피 줄 — 줄 맨 앞(공백 허용)의 `--@`. `--+`(힌트)·`-- @`(보통 주석)와 겹치지 않는다 */
export const BOOKMARK_RE = /^\s*--@[ \t]?(.*)$/;
export const BOOKMARK_PREFIX = '--@ ';

/** 한 줄이 책갈피인가 — 이름(빈 문자열일 수 있음) 또는 null */
export function bookmarkName(lineText) {
    const m = BOOKMARK_RE.exec(lineText || '');
    return m ? m[1].trim() : null;
}

/** 문서의 책갈피 — [{ line(1부터), name }] */
export function parseBookmarks(text) {
    if (!text || text.indexOf('--@') < 0) return [];
    const out = [];
    const lines = text.split('\n');
    for (let i = 0; i < lines.length; i++) {
        const name = bookmarkName(lines[i].replace(/\r$/, ''));
        if (name !== null) out.push({ line: i + 1, name });
    }
    return out;
}
